import { useEffect } from 'react';
import { get } from 'lodash';
import { useQuery } from '@tanstack/react-query';
import dimensionsStore from '@globalStore/dimensionsStore';
import { getDimensions } from '@src/api/dimensionContainer';

const context = window.conviva.context;

function useDimensionsMeta() {
  const setDimensionsMeta = dimensionsStore((state) => state.setDimensionsMeta);
  const {
    data: dimensionsMeta,
    isLoading: isDimensionsMetaApiLoading,
    refetch: reFetchDimensionsMetaMeta,
  } = useQuery(['dimensions-meta'], () =>
    getDimensions({
      context,
    }), {
    retry: 3,
    staleTime: Infinity,
    cacheTime: Infinity,
    refetchOnWindowFocus: false,
    select: (response) => get(response, ['data'], {}),
  });

  useEffect(() => {
    if (dimensionsMeta && dimensionsMeta.length > 0) {
      setDimensionsMeta(dimensionsMeta);
    }
  }, [dimensionsMeta]);

  const forceUpdateDimensionsMeta = () => {
    reFetchDimensionsMetaMeta();
  };

  return {
    forceUpdateDimensionsMeta,
    isDimensionsMetaApiLoading,
  };
}

export default useDimensionsMeta;
